import { IconContent } from '@icons';

export const cross: IconContent = {
    sm: '<path d="m8 8.707 3.536 3.536.707-.707L8.707 8l3.536-3.536-.707-.707L8 7.293 4.464 3.757l-.707.707L7.293 8l-3.536 3.536.707.707L8 8.707Z" />',
};
